import request from "../api/httpClient.js";
import getEndpoint from "../utils/getEndpoint.js";

export const getMe = async () => {
  const user = await request(getEndpoint("user", "getMe"));
  return user.data;
};

export const getUser = async (userId) => {
  const user = await request(getEndpoint("user", "getUser", userId));
  return user.data;
};

export const updateMe = async (payload) => {
  const user = await request(getEndpoint("user", "updateMe"), { body: payload });
  return user.data;
};

export const updateMyProfilePicture = async (file) => {
  const formData = new FormData();
  formData.append("profile-picture", file);
  const user = await request(getEndpoint("user", "updateMyProfilePicture"), { body: formData });
  return user.data;
};

export const deleteMyProfilePicture = async () => {
  const user = await request(getEndpoint("user", "deleteMyProfilePicture"));
  return user.data;
};

export const deleteMe = async () => {
  await request(getEndpoint("user", "deleteMe"));
};

export const getUsers = async (query) => {
  const res = await request(getEndpoint("user", "getUsers"), { query });
  return res.data;
};
